import React from "react";
import Alert from "../../../components/Alert";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import {
  actionPutAlertasReconhecer,
  actionResetPutAlertasReconhecer,
} from "../../../features/alertas/reconhecer/slices";
import { actionGetAlertasAbertos } from "../../../features/alertas/slices";
import transformDate from "../../../helpers/transform-date";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { toast } from "sonner";

const Actions = ({ close, confirm }) => {
  const { putAlertasReconhecer } = useAppSelector((state) => state);

  return (
    <nav className="actions">
      <Button size="sm" variant="secondary" onClick={close}>
        Fechar
      </Button>
      <Button
        size="sm"
        variant="primary"
        onClick={confirm}
        loading={putAlertasReconhecer.status === "loading"}
      >
        Confirmar
      </Button>
    </nav>
  );
};

const ModalReconhecer = ({ close, data }) => {
  const dispatch = useAppDispatch();
  const { putAlertasReconhecer } = useAppSelector((state) => state);

  const { id, descricao, status, dataEvento } = data;

  console.log("ModalReconhecer data", data);

  const confirm = async () => {
    await dispatch(actionPutAlertasReconhecer(id));
    await dispatch(actionGetAlertasAbertos(data.idLoja));
    close();    
  };

  const handleClose = () => {
    dispatch(actionGetAlertasAbertos({ idLoja: data.idLoja }));
    dispatch(actionResetPutAlertasReconhecer());
    close();
  };

  return (
    <Modal
      size="sm"
      header={<h3 className="heading--sm">Reconhecer alerta {id}?</h3>}
      actions={<Actions close={handleClose} confirm={confirm} />}
    >
      <p className="paragraph mb-10">
        <strong>Data evento:</strong> {transformDate(dataEvento, true)}{" "}
      </p>
      <p className="paragraph mb-10">
        <strong>Descrição:</strong> {descricao}{" "}
      </p>
      <p className="paragraph">
        <strong>Status:</strong> {status}{" "}
      </p>
    </Modal>
  );
};

export default ModalReconhecer;
